module.exports = __webpack_public_path__ + "img/sonline.13dea7f1.png";